import {Elements} from 'react-flow-renderer';
import {useMemo} from 'react';
import {WorkspaceElementData} from '../../components/workspace-view';
import {PlanElementData} from '../../components/plan-element-view';

export interface UseFlowElementsResult {
  elements: Elements;
}

export const useFlowElements = (
  workspaces: Elements<WorkspaceElementData>,
  rooms: Elements<PlanElementData>,
  planElements: Elements<PlanElementData>,
): UseFlowElementsResult => {
  const elements = useMemo(() => {
    if (!workspaces?.length && !rooms?.length && !planElements?.length) {
      return [];
    }

    return [...rooms, ...planElements, ...workspaces];
  }, [workspaces, rooms, planElements]);

  return {
    elements,
  };
};
